import React, { useEffect, useState } from "react";
import { Modal, Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import left_arrow from "../../../assets/images/icons/left_arrow_wht.svg";
import Loader from "../../../Loader/Loader";
import {
  coachAddProgram,
  coachProgramDetails,
  coachUpdateProgram,
  getCategoryList,
} from "../../../utils/api";
import { useLocation } from "react-router-dom";

function AddSessionsComponent() {
  const [durationOptions, setDurationOptions] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState(null);
  const [programs, setprograms] = useState([]);
  const [sessionType, setSessionType] = useState("Single");
  const [dataArray, setDataArray] = useState([]);
  const [deletedSessions, setdeletedSessions] = useState([]);
  const [session_name, setSession_name] = useState("");
  const [session_duration, setSession_duration] = useState("");
  const [sessionNameError, setSessionNameError] = useState(false);
  const [sessionDuration, setSessionDuration] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedTab } = location.state || {};
  // const selectedTab  =localStorage.setItem("selectedTab", selectedTab);

  useEffect(() => {
    if (selectedTab) {
      setSessionType(selectedTab === "first" ? "Single" : "Multiple");
    }
  }, [selectedTab]);
  const handleDurationChange = (selectedOption) => {
    setSelectedDuration(selectedOption.value);
    formik.setFieldValue('P_duration', selectedOption.value); // Set the duration in formik's state
  };

  const allDurations = [
    { label: "30 Minutes", value: 30 },
    { label: "1 Hour", value: 60 },
    { label: "1 hour 30 Minutes", value: 90 },
    { label: "2 Hour", value: 120 },
  ];

  const handleInputChange1 = (event) => {
    console.log("eeee",event.target.value)
    setSession_name(event.target.value);
    setSessionNameError(false);
  };

  const handleInputChange2 = (event) => {
    console.log(event.target.value)
    setSession_duration(event.target.value);
    setSessionDuration(false);
  };

  const handleAddButtonClick = () => {
    if (!session_name || !session_duration) {
      if (!session_name) setSessionNameError(true);
      if (!session_duration) setSessionDuration(true);
      return;
    }

    const newObject = {
      id: Math.random(),
      session_name: session_name,
      session_duration: session_duration,
    };

    setDataArray([...dataArray, newObject]);
    setSession_name("");
    setSession_duration("");
  };

  const handleAddButtonDelete = (id) => {
    setdeletedSessions([
      ...deletedSessions,
      dataArray?.find((i) => i?.id === id),
    ]);
    setDataArray(dataArray?.filter((i) => i?.id !== id));
  };

  const { sessionId } = useParams(); // Get ID from URL

  useEffect(() => {
    if (sessionId) {
      async function fetchProgramDetails() {
        try {
          const response = await coachProgramDetails(sessionId);
          if (response.data.status) {
            const programData = response.data.data;
            formik.setValues({
              session_title: programData.session_title,
              price: programData.price,
              P_duration: programData.P_duration,
              sessionType: programData.type === "multiple" ? "Multiple" : "Single",
              duration: programData.duration,
              display_title: programData.session_title,
              description: programData.description,
            });
            setSessionType(programData.type === "multiple" ? "Multiple" : "Single");
            //setDataArray(programData.sessions ? programData.sessions : []);

            // Transform sessions into the required format
            setDataArray(
              programData.sessions
                ? programData.sessions.map((session) => ({
                    id: session.id,
                    session_name: session.name, 
                    session_duration: session.duration, 
                  }))
                : []
            );
            
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          console.error("Error fetching program details:", error);
          toast.error("Error fetching program details");
        }
      }
      fetchProgramDetails();
    }
  }, [sessionId]);

  useEffect(() => {

    setDurationOptions(allDurations);

  }, []);

  const handleSessionTypeChange = (event) => {
    setSessionType(event.target.value);
    formik.setValues({
      ...formik.values,
      session_title: "",
      price: "",
      duration: "",
      type: sessionType,
      display_title: "",
      description: "",
      P_duration:""
    });
    localStorage.setItem("selectedTab", event.target.value)
  };

  const formik = useFormik({
    initialValues: {
      session_title: "",
      price: "",
      P_duration: "",
      sessionType: "Single",
      duration: "",
      display_title: "",
      description: "",
    },
    validationSchema: sessionType === "Single" ?
      Yup.object().shape({
        session_title: Yup.string().required("Session Title is required").max(150),
        price: Yup.number().required("Price is required"),
        duration: Yup.number().required("Duration is required"),
        display_title: Yup.string().required("Session Title is required").max(150),
      }) :
      Yup.object().shape({
        session_title: Yup.string().required("Session Title is required").max(150),
        price: Yup.number().required("Price is required"),
        duration: Yup.number().required("Duration is required"),
      }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        if(sessionType === 'Multiple'){
          if(dataArray.length === 0){
            toast.error("please add duration for multiple session.");
            return;
          }
        }
        values.sessions = sessionType === "Multiple" ? JSON.stringify(dataArray) : "";
        values.type = sessionType.toLowerCase();
        values.session_number = sessionType === "Single" ? 1 : undefined;

        let response;
        if (sessionId) {
          values.program_id = sessionId;
          console.log(values);
          response = await coachUpdateProgram(values); // Update existing program
        } else {
          response = await coachAddProgram(values); // Add new program
        }

        if (response.data.status) {
          toast.success(`Program ${sessionId ? "updated" : "added"} successfully`);
          if (!sessionId) {
            setShowModal(true);
            resetForm();
            setDataArray([]);
            setSelectedDuration(null);
          }
          else{
            navigate('/coach/sessions', { state: { renderTab: sessionType} });

            // navigate("/coach/sessions")
          }
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error(`Error ${sessionId ? "updating" : "adding"} program:`, error);
        toast.error(`Error ${sessionId ? "updating" : "adding"} program`);
      } finally {
        setSubmitting(false);
      }
    }
  });

  return (
    <section className="sessions_pages">
      <div className="text-start hdng_a mb-3 d-flex gap-3 align-items-center">
        <Button variant="success" className="rounded-circle" onClick={() => navigate("/coach/sessions",{ state: { renderTab: sessionType}})}>
          <img src={left_arrow} alt="Back" />
        </Button>
        <h2 className="fs-20 fw-500 m-0">{sessionId ? "Update Session" : "Add Session"}</h2>
      </div>
      <Formik
      >
      {({ errors, touched, setFieldValue, values, isSubmitting }) => (
        <Form onSubmit={formik.handleSubmit}>
          <>
          <Row>            
              <Col lg="12">
                <Form.Group className="mb-3" controlId="">
                  <Form.Label className="title">
                    Choose Session Type
                  </Form.Label>
                  <div className="d-flex py-2">
                    <Form.Check
                      type="radio"
                      name="sessionType"
                      label="Single"
                      value="Single"
                      className="mx-2"
                      checked={sessionType === "Single"}
                      onChange={handleSessionTypeChange}
                      disabled={sessionId && sessionType === "Multiple"} 
                    />
                    <Form.Check
                      type="radio"
                      name="sessionType"
                      label="Multiple"
                      value="Multiple"
                      className="mx-2"
                      checked={sessionType === "Multiple"}
                      onChange={handleSessionTypeChange}
                      disabled={sessionId && sessionType === "Single"}
                    />
                  </div>
                </Form.Group>
              </Col>
              {sessionType === "Single" ? (
                <Row>
                  <Col lg="12">
                    <Form.Group className="mb-3" controlId="">
                      <Form.Control
                        type="text"
                        name={`session_title`}
                        placeholder="Enter Program Name"
                        value={formik.values.session_title}
                        onChange={formik.handleChange}
                        isInvalid={
                          formik?.touched?.session_title &&
                          !!formik?.errors?.session_title
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik?.errors?.session_title &&
                          formik?.touched?.session_title && (
                            <div>{formik?.errors?.session_title}</div>
                          )}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg="12">
                    <Form.Group className="mb-3" controlId="">
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Enter About Program"
                        value={formik.values.description}
                        name="description"
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg="4">
                    <Form.Group className="mb-3" controlId="">
                      <Form.Control
                        type="text"
                        name={`price`}
                        value={formik.values.price}
                        placeholder="Program Price ($)"
                        onChange={(e) => {
                          formik.handleChange(e.target.value.replace(/[^0-9]/g, ""))
                          const numericValue = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          formik.setFieldValue("price", numericValue);
                        }}
                        // onChange={formik.handleChange}
                        isInvalid={
                          formik?.touched?.price && !!formik?.errors?.price
                        }
                        onKeyDown={(e) => {
                          if (e.key === "e" || e.key === "E" || e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik?.errors?.price && formik?.touched?.price && (
                          <div>{formik?.errors?.price}</div>
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg="4">
                    <Form.Group className="mb-3" controlId="">
                      <Form.Control
                        type="text"
                        name={`price`}
                        value={formik.values.price * 0.05}
                        placeholder="Price ($)"
                        disabled={true}
                        // onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* <Col lg="4"></Col> */}

                  <Col lg="8">
                    <Form.Group className="mb-3" controlId="">
                      <Form.Control
                        type="text"
                        name={`display_title`}
                        value={formik.values.display_title}
                        placeholder="Session Title"
                        onChange={formik.handleChange}
                        isInvalid={
                          formik?.touched?.display_title &&
                          !!formik?.errors?.display_title
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik?.errors?.display_title &&
                          formik?.touched?.display_title && (
                            <div>{formik?.errors?.display_title}</div>
                          )}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg="4">
                    <Form.Group className="mb-3" controlId="">
                      <Form.Control
                        type="number"
                        name={`duration`}
                        value={formik.values.duration}
                        placeholder="Session Duration(in minutes)"
                        onChange={formik.handleChange}
                        isInvalid={
                          formik?.touched?.duration &&
                          !!formik?.errors?.duration
                        }
                        onKeyDown={(e) => {
                          if (e.key === "e" || e.key === "E" || e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}
                      /> 
                      {/* <Select
                        name="duration"
                        value={allDurations.find(option => option.value === formik.values.duration)}
                        onChange={(selectedOption) => {
                          formik.setFieldValue("duration", selectedOption.value);
                        }}
                        options={allDurations}
                        placeholder="Select a Duration"
                        onBlur={() => formik.setFieldTouched("duration", true)} // Mark field as touched
                      />*/}
                      <Form.Control.Feedback type="invalid">
                        {formik?.errors?.duration &&
                          formik?.touched?.duration && (
                            <div>{formik?.errors?.duration}</div>
                          )}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              ) : (
                <>
                  <Row>
                    <Col lg="6">
                      <Form.Group className="mb-3" controlId="">
                        <Form.Control
                          type="text"
                          name={`session_title`}
                          placeholder="Program Name"
                          value={formik.values.session_title}
                          onChange={formik.handleChange}
                          isInvalid={
                            formik?.touched?.session_title &&
                            !!formik?.errors?.session_title
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik?.errors?.session_title &&
                            formik?.touched?.session_title && (
                              <div>{formik?.errors?.session_title}</div>
                            )}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg="12">
                      <Form.Group className="mb-3" controlId="">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Enter About Program"
                          value={formik.values.description}
                          name="description"
                          onChange={formik.handleChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col lg="6">
                      <Form.Group className="mb-3" controlId="">
                        <Form.Control
                          type="number"
                          name={`price`}
                          value={formik.values.price}
                          placeholder="Program Price ($)"
                          onChange={formik.handleChange}
                          isInvalid={
                            formik?.touched?.price && !!formik?.errors?.price
                          }
                          onKeyDown={(e) => {
                            if (e.key === "e" || e.key === "E" || e.key === "-" || e.key === "+") {
                              e.preventDefault();
                            }
                          }}S
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik?.errors?.price &&
                            formik?.touched?.price && (
                              <div>{formik?.errors?.price}</div>
                            )}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg="3">
                    <Form.Group className="mb-3" controlId="">
                      <Form.Control
                        type="text"
                        name={`price`}
                        value={formik.values.price * 0.05}
                        placeholder="Price ($)"
                        disabled={true}
                        // onChange={formik.handleChange}
                      />
                    </Form.Group>
                  </Col>
                    <Col lg="6">
                      <Form.Group className="mb-3" controlId="">
                        <Form.Control
                          type="number"
                          name={`duration`}
                          value={formik.values.duration}
                          placeholder="Program Duration(in Days)"
                          onChange={formik.handleChange}
                          isInvalid={
                            formik?.touched?.duration &&
                            !!formik?.errors?.duration
                          }
                          onKeyDown={(e) => {
                            if (e.key === "e" || e.key === "E" || e.key === "-" || e.key === "+") {
                              e.preventDefault();
                            }
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          {formik?.errors?.duration &&
                            formik?.touched?.duration && (
                              <div>{formik?.errors?.duration}</div>
                            )}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  {dataArray?.map((i) => {
                    return (
                      <Row>
                        <Col lg="5">
                          <Form.Group className="mb-3" controlId="">
                            <Form.Control
                              type="text"
                              value={i?.session_name}
                              disabled
                            />
                          </Form.Group>
                        </Col>
                        <Col lg="6">
                          <Form.Group className="mb-3" controlId="">
                            <Form.Control
                              type="number"
                              value={i?.session_duration}
                              disabled
                            />
                          </Form.Group>
                        </Col>
                        <Col className="mb-3" lg="1">
                          <Button
                            onClick={() => handleAddButtonDelete(i?.id)}
                            variant="danger"
                            className="px-4"
                          >
                            Delete
                          </Button>
                        </Col>
                      </Row>
                    );
                  })}
                  <Row>
                    <Col lg="5">
                      <Form.Group className="mb-3" controlId="">
                        <Form.Control
                          type="text"
                          value={session_name}
                          onChange={handleInputChange1}
                          placeholder="Session Title"
                          isInvalid={sessionNameError}
                        />
                        <Form.Control.Feedback type="invalid">
                          {sessionNameError && (
                            <span style={{ color: "red" }}>
                              This field is required.
                            </span>
                          )}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg="6">
                      <Form.Group className="mb-3" controlId="">
                        <Form.Control
                          type="number"
                          placeholder="Session Duration(in minutes)"
                          value={session_duration}
                          onChange={handleInputChange2}
                          isInvalid={sessionDuration}
                          onKeyDown={(e) => {
                            if (e.key === "e" || e.key === "E" || e.key === "-" || e.key === "+") {
                              e.preventDefault();
                            }
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          {sessionDuration && (
                            <span style={{ color: "red" }}>
                              This field is required.
                            </span>
                          )}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col className="mb-3" lg="1">
                      <Button
                        onClick={handleAddButtonClick}
                        variant="success"
                        className="px-4"
                        disabled={!session_duration || !session_name}
                      >
                        Add
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
              <Row className="justify-content-end">
              <Col sm="auto">
                <Button type="submit" variant="success" className="px-4" disabled={formik.isSubmitting}>
                  {formik.isSubmitting ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />{' '} &nbsp;
                      {sessionId ? " Updating..." : " Adding..."}
                    </>
                  ) : (sessionId ? " Update Program" : " Add Program")}
                </Button>
              </Col>
            </Row>  
          </Row>
          </>
        </Form>
      )}
      </Formik>  

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Program Added</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Would you like to view the list or add another session?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => navigate("/coach/sessions" ,{ state: { renderTab: sessionType}})}>View List</Button>
          <Button variant="primary" onClick={() => setShowModal(false)}>Add More</Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}

export default AddSessionsComponent;
